import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import type { Banner, BannerFilters, BannerType } from '@/types';
import createQueryString from '@/utils/queryString';

export const useBannersStore = defineStore('banners', () => {
    const banners = ref<Record<BannerType, Banner[]>>({} as Record<BannerType, Banner[]>);
    function toResetBanners() {
        banners.value = {} as Record<BannerType, Banner[]>;
    }
    const awaitGetBanners = async (filters: BannerFilters) => {
        const queryString = createQueryString(filters);
        try {
            const response = await axios.get<Banner[]>(`/main-api/banners/${queryString}`);
            if (response.status === 200) {
                banners.value[filters.banner_type] = response.data;
            }
        } catch (error) {
            console.error(error);
        }
    };

    return { banners, awaitGetBanners, toResetBanners };
});
